import { ModeView } from '../../../shared/ontology/model/mode-view.enum';

export interface EditableMetadata {
    editable?: boolean;
    editableFields?: string[];
}

export interface HasMetadata {
    metadata?: EditableMetadata | null;
}

export function canEditFieldByMetadata(model: HasMetadata | null | undefined, property: string): boolean {
    if (!model?.metadata) {
        return false;
    }

    const metadata = model.metadata;
    const editableFields = metadata.editableFields ?? [];

    if (editableFields.length > 0) {
        return editableFields.includes(property);
    }

    return metadata.editable === true;
}

export function isEditableByMode(params: {
    modeView: ModeView
    model?: HasMetadata | null;
    property: string;
}): boolean {
    const { modeView, model, property } = params;

    if (modeView === ModeView.CREATE) {
        return true;
    } else if (modeView === ModeView.EDIT) {
        return canEditFieldByMetadata(model, property);
    }

    // VIEW
    return false;
}
